import React, { useState } from "react";
import withReduxProvider from "web/react/redux-provider";
import PropTypes from "prop-types";
import Button from "web/react/components/button/button";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import requester from "web/script/modules/requester";
import facebookEvents from "web/script/analytics/facebook-events";
import doubleclickEvents from "web/script/analytics/doubleclick-events";
import { incrementBasketCount } from "web/redux/ducks/app-header-cart";
import { openShippingAndReturnsOverlay } from "web/redux/ducks/shipping-and-returns-overlay";
import { connect } from "react-redux";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "../../svg-icon/svg-icon";
import styles from "./product-description-express-checkout.css";


function mapDispatchToProps(dispatch) {
    return {
        incrementBasketCount: () => dispatch(incrementBasketCount()),
        openShippingAndReturnsOverlay: (linkId) => dispatch(openShippingAndReturnsOverlay(linkId)),
    };
}

export function ProductDescriptionExpressCheckout({
    openShippingAndReturnsOverlay,
    className,
    incrementBasketCount,
    isSavedForLater,
    productId,
    sizeGuideLink,
    sizes,
    showBuyOnLyst,
}) {
    const [expanded, setExpanded] = useState(showBuyOnLyst);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [buyButtonEnabled, setBuyButtonEnabled] = useState(true);

    function handleSizeChange(event) {
        setSelectedIndex(event.target.selectedIndex);
        analytics.event("express_checkout", "changed_size");
    }

    function handleSeeMore(event) {
        event.preventDefault();
        setExpanded(true);
        analytics.event("express_checkout", "clicked_more_buy_options");
    }

    function handleClickOverlay(event) {
        event.preventDefault();
        const optionValue = sizes[selectedIndex].option_value;
        openShippingAndReturnsOverlay(optionValue.link_id);
    }

    function handleClickSizeGuide() {
        analytics.event("express_checkout", "show_size_guide");
    }

    function _sendBuyActionAnalytics() {
        const label = isSavedForLater ? "save_for_later_add_to_cart" : "add_to_cart_button";

        const analyticsPromises = [
            analytics.event("CART", "ADD_ITEM", label),
            analytics.tagEvent(
                analytics.TAG_NETWORKS.FACEBOOK,
                facebookEvents.ADD_TO_CART,
                {
                    content_ids: productId,
                    content_type: "product",
                },
                true
            ),
            analytics.tagEvent(analytics.TAG_NETWORKS.DOUBLECLICK, doubleclickEvents.ADD_TO_CART, {
                path: window.location.pathname,
                size: sizes[selectedIndex].raw_size,
            }),
        ];
        return Promise.all(analyticsPromises);
    }

    async function addToBag() {
        const method = "POST";
        setBuyButtonEnabled(false);
        const optionValue = sizes[selectedIndex].option_value;
        const requestObj = {
            icon: true,
            raw_size: optionValue.raw_size,
            link_id: optionValue.link_id,
        };

        const body = {
            buy_option: JSON.stringify(requestObj),
            is_base64_encoded: false,
        };

        _sendBuyActionAnalytics().catch(() => {
            console.error("Analytics on buy action failed.");
        });

        await requester("/cart/add/", { method, body })
            .then(requester.toJSON)
            .then((response) => {
                if (!response.success) {
                    let error = new Error();
                    error.response = response;
                    throw error;
                } else {
                    incrementBasketCount();
                }
            })
            .catch(() => {
                analytics.event("CART", "ADD_TO_BAG_ERROR");
            });

        setBuyButtonEnabled(true);
    }

    if (!expanded) {
        return (
            <a href="#" onClick={handleSeeMore} className={classnames(className, styles.seeMore)}>
                <SVGIcon name="chevron" rotate={90} />
                {gettext("product.buy_area.see_more_buying_options")}
            </a>
        );
    } else {
        return (
            <div className={className}>
                <form>
                    <div className={styles.selectDropDown}>
                        <select className={styles.selectDropDownInput} onChange={handleSizeChange}>
                            {sizes.map((size) => {
                                return (
                                    <option key={size.raw_size}>
                                        {size.human_size}
                                        {" - "}
                                        {size.min_price}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </form>
                <div className={styles.viewInfo}>
                    <a
                        href={sizeGuideLink}
                        onClick={handleClickSizeGuide}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {gettext("product.buy_area.view_size_guide")}
                    </a>
                </div>

                <Button
                    onClick={addToBag}
                    fullWidth
                    styleType="temp-grey"
                    disabled={!buyButtonEnabled}
                >
                    <div className={styles.buyOnLyst}>
                        <SVGIcon name="basket-icon" />
                        <span>{gettext("product.buy_area.buy_on_lyst")}</span>
                    </div>
                </Button>
                <div className={styles.viewInfo}>
                    <a href="#" onClick={handleClickOverlay}>
                        {gettext(
                            "product.buy_area.open_view_shipping_and_returns_info_overlay_btn_text"
                        )}
                    </a>
                </div>
            </div>
        );
    }
}

ProductDescriptionExpressCheckout.propTypes = {
    sizeGuideLink: PropTypes.string,
    sizes: PropTypes.arrayOf(
        PropTypes.shape({
            option_value: PropTypes.shape({
                link_id: PropTypes.string,
                raw_size: PropTypes.string,
                icon: PropTypes.bool,
            }),
            human_size: PropTypes.string,
            raw_size: PropTypes.string,
            min_price: PropTypes.number,
        })
    ),
    showBuyOnLyst: PropTypes.bool,
};

export default withReduxProvider(
    connect(
        null,
        mapDispatchToProps
    )(ProductDescriptionExpressCheckout)
);
